<template>
  <div
    style="overflow:auto;-webkit-overflow-scrolling:touch"
    class="pt-5 px-4"
  >
    <!-- <script src="https://agency.enginehire.io/src/assets/js/embedded_script.js"></script> -->
    <iframe
      style="border: none;"
      id="enginehire-iframe"
      src="https://pebble.enginehire.io/403/jobs"
      width="100%"
      height="20300"
    ></iframe>
  </div>
</template>

<script>
export default {
  created() {
    // this.$store.dispatch('tryAutoLogin')
    // Scroll the window up
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Jobs.vue